import { ArrowLeft } from 'lucide-react';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { PageTitle } from '../PageTitle';
import { PageWrapper } from '../PageWrapper';

interface FormPageLayoutProps {
  title: string;
  isEditMode?: boolean;
  onBack?: () => void;
  backLabel?: string;
  /** Maksymalna szerokość nagłówka i treści w px, wyśrodkowane (np. formularz dwukolumnowy); brak = cała szerokość. */
  maxWidth?: number;
  children: ReactNode;
}

const Constrained = styled.div<{ $maxWidth?: number }>`
  width: 100%;
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'none')};
  margin: 0 auto;
`;

/** Układ strony formularza BEZ asystenta AI: ten sam nagłówek i link powrotu co w FormWithAiLayout. */
export const FormPageLayout: FC<FormPageLayoutProps> = ({
  title, isEditMode, onBack, backLabel, maxWidth, children,
}) => {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <Constrained $maxWidth={maxWidth}>
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="mb-3 inline-flex items-center gap-1.5 text-sm text-text-secondary hover:text-text-primary hover:underline"
          >
            <ArrowLeft size={14} strokeWidth={2} />
            {backLabel ?? t('common.back', 'Powrót')}
          </button>
        )}
        <PageTitle isEditMode={isEditMode} title={title} />
        <div className="pt-1">{children}</div>
      </Constrained>
    </PageWrapper>
  );
};
